<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" :columns="columns" :paginationSwitch = "false"
            :resultData.sync="upstreamChannelStatistics" :pageFooterLoading="pageFooterLoading"
            @request-result="onResult" @reset="reset" @sortedFormatter="sortedFormatter">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.date')">
            <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                v-model="form.date"
                value-format="yyyyMMdd"
                :placeholder="$t('message.chooseDay')"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">

          <el-button :loading="loading" type="primary" @click="generateStatisticsToday" size="small">
            {{ $t('text.refreshToday') }}
          </el-button>

          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
        </template>

        <template slot="pageHeader">
          <el-row :gutter="16" style="margin-top: 15px">
            <el-col :xs="24" :sm="12">
              <el-statistic :value="null">
                <template #title>
                  <div style="display:inline-flex;align-items:center">
                    {{ $t('text.date') }} :
                  </div>
                </template>
                <template #suffix>
                  <div> {{ statisticsDate }}</div>
                </template>
              </el-statistic>
            </el-col>

            <el-col :xs="24" :sm="12">
              <el-statistic :value="null">
                <template #title>
                  <div style="display:inline-flex;align-items:center">
                    {{ $t('text.updateTime') }} :
                  </div>
                </template>
                <template #suffix>
                  <div> {{ updateTimeL }}</div>
                </template>
              </el-statistic>
            </el-col>
          </el-row>
          <h1>
            上游
          </h1>
        </template>

        <template slot="pageFooter">
          <h1 style="margin-left: 10px"> 下游 </h1>
          <el-descriptions
              :column="1"
              border
          >
            <el-descriptions-item :label="$t('text.allMerchantBalance')" :labelStyle='labelStyle'>
              {{ allMerchantBalanceView }}
            </el-descriptions-item>

            <el-descriptions-item :label="$t('text.allMerchantDeposit')" :labelStyle='labelStyle'>
              {{ allMerchantDepositView }}
            </el-descriptions-item>

            <el-descriptions-item :label="$t('text.allMerchantWithdraw')" :labelStyle='labelStyle'>
              {{ allMerchantWithdrawView }}
            </el-descriptions-item>

            <el-descriptions-item :label="$t('text.allAgentFee')" :labelStyle='labelStyle'>
              {{ allAgentFeeView }}
            </el-descriptions-item>
          </el-descriptions>
        </template>
      </page>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import moment from "moment";
import StatisticsChannelDetails from "@/views/route/StatisticsChannelDetails.vue";

export default {
  components: {
    page: Page,
    StatisticsChannelDetails: StatisticsChannelDetails,
  },
  data() {
    return {
      loading: false,
      pageFooterLoading: true,
      exporting: false,
      form: {
        date: moment().subtract(1, 'days').format('yyyyMMDD'),
      },
      url: '/statistics-accounting/listStatisticsAccounting',
      statisticsDate: "...",
      updateTimeL: "...",
      allMerchantBalance: "...",
      allMerchantBalanceView: "...",
      allMerchantDeposit: "...",
      allMerchantDepositView: "...",
      allMerchantWithdraw: "...",
      allMerchantWithdrawView: "...",
      allAgentFee: "...",
      allAgentFeeView: "...",
      upstreamChannelStatistics: null,
      allUpstreamPayinAmount: "...",
      allUpstreamPayinAmountView: "...",
      allUpstreamPayoutAmount: "...",
      allUpstreamPayoutAmountView: "...",
      allUpstreamBalance: "...",
      allUpstreamBalanceView: "...",
      labelStyle: {'width': '180px'},
      columns: [
        {prop: 'upstreamName', label: 'text.channel'},
        {
          prop: 'payinAmount',
          label: 'text.collection',
          formatter: this.$formatter.FenToYuanToThousandth,
          sortable: 'custom'
        },
        {
          prop: 'payoutAmount',
          label: 'text.disbursement',
          formatter: this.$formatter.FenToYuanToThousandth,
          sortable: 'custom'
        },
        {
          prop: 'balance',
          label: 'text.balance',
          formatter: this.$formatter.FenToYuanToThousandth,
          sortable: 'custom'
        },
      ],
    };
  },
  methods: {
    onResult(data) {
      data = data[0];
      this.loading = true;
      // 初始化
      this.statisticsDate = "...";
      this.updateTimeL = "...";
      this.allMerchantBalance = "...";
      this.allMerchantBalanceView = "...";
      this.allMerchantDeposit = "...";
      this.allMerchantDepositView = "...";
      this.allMerchantWithdraw = "...";
      this.allMerchantWithdrawView = "...";
      this.allAgentFee = "...";
      this.allAgentFeeView = "...";
      this.upstreamChannelStatistics = null;
      this.allUpstreamPayinAmount = 0;
      this.allUpstreamPayinAmountView = "...";
      this.allUpstreamPayoutAmount = 0;
      this.allUpstreamPayoutAmountView = "...";
      this.allUpstreamBalance = 0;
      this.allUpstreamBalanceView = "...";

      const toList = (val) => {
        if (!val) return [];
        try {
          const v = typeof val === 'string' ? JSON.parse(val) : val;
          return Array.isArray(v) ? v : [v];
        } catch (e) {
          return [];
        }
      };

      this.statisticsDate = this.$formatter.formatDate(null, null, data.statisticsDate, null);
      this.updateTimeL = this.$formatter.formatDate(null, null, data.updateTimeL, null);

      this.allMerchantBalance = this.$formatter.FenToYuan(null, null, data.allMerchantBalance, null);
      this.allMerchantBalanceView = this.allMerchantBalance.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      this.allMerchantDeposit = this.$formatter.FenToYuan(null, null, data.allMerchantDeposit, null);
      this.allMerchantDepositView = this.allMerchantDeposit.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      this.allMerchantWithdraw = this.$formatter.FenToYuan(null, null, data.allMerchantWithdraw, null);
      this.allMerchantWithdrawView = this.allMerchantWithdraw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      this.allAgentFee = this.$formatter.FenToYuan(null, null, data.allAgentFee, null);
      this.allAgentFeeView = this.allAgentFee.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 关键：把 JSON 或对象统一成 list
      this.upstreamChannelStatistics = toList(data.upstreamChannelStatistics);

      this.upstreamChannelStatistics.forEach(statistic => {
        this.allUpstreamPayinAmount += this.toNumber(statistic["payinAmount"]);
        this.allUpstreamPayoutAmount += this.toNumber(statistic["payoutAmount"]);
        this.allUpstreamBalance += this.toNumber(statistic["balance"]);
      });

      const totalRow = {
        upstreamName: '小计',
        payinAmount: this.allUpstreamPayinAmount,
        payoutAmount: this.allUpstreamPayoutAmount,
        balance: this.allUpstreamBalance
      };

      this.upstreamChannelStatistics = [
        ...(this.upstreamChannelStatistics || []),
        totalRow
      ];


      this.loading = false;
    },
    reset() {
      this.form.date = moment().subtract(1, 'days').format('yyyyMMDD');
    },
    toNumber(val) {
      if (val === null || val === undefined || val === '') return 0;
      const s = val.toString().trim().replace(/,/g, '').replace(/%$/, '');
      const n = Number(s);
      return Number.isNaN(n) ? 0 : n;
    },
    sortedFormatter({column, prop, order}) {
      const comparator = (a, b) => {
        const aVal = this.toNumber(a[prop]);
        const bVal = this.toNumber(b[prop]);

        const aZero = aVal === 0;
        const bZero = bVal === 0;

        if (aZero && !bZero) return 1;
        if (!aZero && bZero) return -1;
        if (aZero && bZero) return 0;

        return order === 'ascending' ? aVal - bVal : bVal - aVal;
      };

      const arr = [...this.upstreamChannelStatistics];
      const last = arr[arr.length - 1];
      const isSubtotal = last && (last.upstreamName === '小计' || last.__isSubtotal === true);

      const body = isSubtotal ? arr.slice(0, -1) : arr;
      const tail = isSubtotal ? [last] : [];

      const sorted = body.sort(comparator);
      this.upstreamChannelStatistics = [...sorted, ...tail];

      if (column) column.sortMethod = order ? comparator : undefined;
    },
    generateStatisticsToday() {
      this.$axios.get('/statistics-accounting/generateStatisticsToday', {params: {}})
          .then(res => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: 'success',
              })

              this.$bus.$emit('refresh') //通知刷新
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              })
            }
          })
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/statistics-accounting/listStatisticsAccountingExport", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.accountingReportExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>